import { AccessLevel, PagedResults } from "../models/generics";
import { LoaderMetadata, MetaLoaderListDTO, Rag, RagConfigs, RagListDTO, RagLoader } from "../models/LLM";
import client from "./axios";

const llmPlatformUrl = `${window.__env.GATEWAY_URL}/v1/llm`;

type LoaderChunksRequestBody = {
  piece_index?: number;
  splittingConf?: Record<string, any>;
}

export interface ChunkMetadata {
  chunk: string;
  chunk_index: number;
  total_chunks: number;
}

interface TestLoaderResponse {
  is_working: boolean;
  error: string;
}

interface InvokeBody {
  input: { question: string };
  thread_id: string;
}
// type RetrieveBody = Pick<InvokeBody, 'context' | 'input'>;

interface InvokeReponse {
  question: string;
  answer: {
    id: string,
    content: string,
    type: string,
  }
}

export interface EmbedBody {
  jobId: string;
  ragId: number;
  loaderId: number;
  splittingConf: any;
  accessLevel: AccessLevel;
  organizationId: string;
  ownerId: string;
}

export interface LlmModel {
  details: {
    families: string[];
    family: string;
    format: string;
    parameter_size: string;
    parent_model: string;
    quantization_level: string;
  },
  digest: string;
  model: string;
  modified_at: string;
  name: string;
  size: number;
}

// TODO fix all paths and flows (from gateway, from rag and from events)
export const Llm = {
  getModels: () => client.get<LlmModel[]>(`${llmPlatformUrl}/ollama/models`),
  pullModels: (model: any) => client.post(`${llmPlatformUrl}/ollama/pull-model`, model),
  getRagsContextConfigs: () => client.get<RagConfigs>(`${llmPlatformUrl}/rags/context-configs`),
  createRag: (rag: RagListDTO) => client.post<RagListDTO>(`${llmPlatformUrl}/rags`, rag),
  getRags: (params?: URLSearchParams) => client.get<PagedResults<RagListDTO> | Array<RagListDTO>>(`${llmPlatformUrl}/rags`, { params }),
  queryRags: (body: any, params?: URLSearchParams) => client.post<PagedResults<RagListDTO> | Array<RagListDTO>>(`${llmPlatformUrl}/rags/query`, body, { params }),
  getRag: (id: string) => client.get<Rag>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}`),
  editRag: (rag: RagListDTO) => client.put<RagListDTO>(`${window.__env.EVENT_GATEWAY_URL}/rag/${rag.id}`, rag),
  updateRagContext: (id: string, context: Record<string, any>) => client.put<Rag>(`${llmPlatformUrl}/rags/${id}/context`, context),
  deleteRag: (id: string) => client.delete(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}`),
  invokeRag: (id: string, body: InvokeBody) => client.post<InvokeReponse>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}/invoke`, body),
  // retrieve: (id: string, body: RetrieveBody) => client.post<InvokeReponse>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}/retrieve`, body),
  embedRagLoader: (body: EmbedBody) => client.post(`${window.__env.EVENT_GATEWAY_URL}/rag/${body.ragId}/embed`, body),
  getLoaders: (params?: URLSearchParams) => client.get<PagedResults<RagLoader> | Array<RagLoader>>(`${llmPlatformUrl}/loaders`, { params }),
  getLoader: (id: string) => client.get<RagLoader>(`${llmPlatformUrl}/loaders/${id}`),
  createLoader: (loader: RagLoader) => client.post<RagLoader>(`${llmPlatformUrl}/loaders`, loader),
  editLoader: (loader: RagLoader) => client.put<RagLoader>(`${llmPlatformUrl}/loaders/${loader.id}`, loader),
  deleteLoader: (id: number) => client.delete(`${llmPlatformUrl}/loaders/${id}`),
  getLoadersDocumentation: () => client.get<MetaLoaderListDTO[]>(`${llmPlatformUrl}/loaders/documentation`),
  getLoaderChunks: (id: number, body: LoaderChunksRequestBody) => client.post<ChunkMetadata>(`${llmPlatformUrl}/loaders/${id}/chunk`, body),
  getLoaderDocumentation: (id: string) => client.get<LoaderMetadata>(`${llmPlatformUrl}/loaders/${id}/documentation`),
  testLoader: (id: number) => client.get<TestLoaderResponse>(`${llmPlatformUrl}/loaders/${id}/test`),
}